export default __webpack_public_path__ + "static/media/hotel-resort-img-15.3ba3c9fd.jpg";